export default "__VITE_ASSET__BXlkzPaX__"